<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("facturacionGeneral") }}</template>
      </breadcrumb>

      <CabeceraInformes v-if="sectores && $cookies.isKey('sectores')" :idBusiness="idBusiness"
        :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom"
        id="cabecera" :conTodos="true" :sectores="true" :listSectores="listaSectores" :idSector="idSector" />
      <CabeceraInformes v-else :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv"
        :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" />

      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12 collapseContainer" v-else-if="respuesta">
        <template v-if="dateInform.length > 0 || dateInformQR.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-6 export-toolbar">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">

                  <a @click="exportForm('Excel', 'Completo')">
                    <el-dropdown-item class="text-success">
                      <strong>
                        <i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcelDeTodosLosTickets") }} {{ $t("conIvaDesglosado") }}</strong>
                    </el-dropdown-item>
                  </a>

                  <a @click="exportForm('Excel', 'CompletoDetalles')">
                    <el-dropdown-item class="text-success">
                      <strong>
                        <i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcelDeTodosLosTickets") }} {{ $t("conDetalles") }}</strong>
                    </el-dropdown-item>
                  </a>

                  <a v-if="idBusiness == 3182" @click="exportForm('Excel', 'FUNDACION_CRUZCAMPO_SAP')">
                    <el-dropdown-item class="text-success">
                      <strong>
                        <i class="fa fa-file-excel"></i>
                        Exportar Excel Fundación Cruzcampo (adaptación SAP)</strong>
                    </el-dropdown-item>
                  </a>

                  <!-- Solo para el Sevilla → v-if="sectores" -->
                  <a v-if="sectores" @click="exportForm('Excel', 'CompletoDetallesNatural')">
                    <el-dropdown-item class="text-success">
                      <strong>
                        <i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcelDeTodosLosTickets") }} {{ $t("porDiaNatural") }}
                      </strong>
                    </el-dropdown-item>
                  </a>

                </el-dropdown-menu>
              </el-dropdown>

              <el-button v-if="idBusiness == 3182" size="small" plain class="btn-historico-sap"
                title="Últimos informes SAP generados automáticamente" @click="abrirHistoricoSAP()">
                <i class="fa fa-history"></i>
                Histórico SAP
              </el-button>
            </div>

            <div class="input-group col-md-6">
              <input type="text" class="form-control" :placeholder="$t('buscarTicket')" v-model="searchQuery"
                @keyup.enter.prevent="searchTickets" />
              <div class="input-group-append">
                <button style="margin-bottom:0px" @click="searchTickets()" class="btn btn-secondary" type="button">
                  <i class="fa fa-search"></i>
                </button>
                <button style="margin-bottom:0px" @click="getTickets()" class="btn btn-secondary" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="col-md-12 export-toolbar-switches">
              <div v-if="existeProducto == true" class="export-toolbar__option">
                <el-switch v-model="checkValue" active-color="#13ce66" inactive-color="#bcbcbc"
                  @change="emitirConsulta()">
                </el-switch>
                <label>
                  <strong>{{ $t('NoMostrarRecargasSaldo') }}</strong>
                </label>
              </div>

              <div class="export-toolbar__option">
                <el-switch v-model="showClienteColumn" active-color="#13ce66" inactive-color="#bcbcbc">
                </el-switch>
                <label>
                  <strong>Mostrar columna cliente</strong>
                </label>
              </div>

              <div v-if="idBusiness == 3182" class="export-toolbar__option">
                <el-switch v-model="exportSapReportWithHeaderDates" active-color="#13ce66" inactive-color="#bcbcbc">
                </el-switch>
                <label>
                  <strong>Exportar SAP con rango de fechas manual</strong>
                </label>
              </div>
            </div>
          </div>
          <el-collapse v-if="dateInformQR.length > 0" v-model="accordion" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <strong>Facturas generadas en Numier FACTURA QR</strong>
              </template>
              <table class="table table-bordered table-striped text-nowrap" style="font-size: 1.1em">
                <thead class="thead-dark">
                  <tr>
                    <th>
                      <span v-if="ordenarFecha" @click="sortedArrayASC(1, index), (ordenarFecha = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("fecha") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(1, index), (ordenarFecha = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("fecha") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarFactura" @click="sortedArrayASC(2, index), (ordenarFactura = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("factura") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(2, index), (ordenarFactura = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("factura") }}
                      </span>
                    </th>
                    <th v-if="showClienteColumn">
                      {{ $t("cliente") }}
                    </th>
                    <th>
                      {{ $t("agencia") }}
                    </th>
                    <th>
                      <span v-if="ordenarTipo" @click="sortedArrayASC(3, index), (ordenarTipo = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("tipo") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(3, index), (ordenarTipo = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("tipo") }}
                      </span>
                    </th>
                    <th>
                      {{ $t("comensales") }}
                    </th>
                    <th> {{ $t("mesa") }} </th>
                    <th>
                      {{ $t("baseMayusculas") }}
                    </th>
                    <th>{{ $t("IVA") }}</th>
                    <th>
                      <span v-if="ordenarTipo" @click="sortedArrayASC(4, index), (ordenarTotal = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("total") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(4, index), (ordenarTotal = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("total") }}
                      </span>
                    </th>
                    <!-- añado esta columna comprobar si ordena bien-->
                    <th style="width : 5%">
                      <span v-if="ordenarTipo" @click="sortedArrayASC(5, index), (ordernarTotalSinDescuento = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("totalSinDescuento") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(5, index), (ordernarTotalSinDescuento = 1)"><i
                          style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("totalSinDescuento") }}
                      </span>
                    </th>
                    <th width="10%">{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in dateInformQR" :key="det.id">
                    <td>
                      <span :class="getClassDay(det.date)">{{ det.date | getDia }}
                        {{ det.date | parseDateMin }}</span>
                    </td>
                    <td>Nº {{ det.idCode }}</td>
                    <!-- <td v-if="det.nameAgencia">{{ det.nameAgencia }}</td>
                      <td v-else>--</td> -->
                    <td v-if="showClienteColumn">
                      {{ det.nameCliente ? det.nameCliente : "--" }}
                    </td>
                    <td>
                      {{ det.nameAgencia ? det.nameAgencia : "--" }}
                    </td>
                    <td v-if="det.status === 'C'">{{ $t("cobrado") }}</td>
                    <td v-else-if="det.status === 'A'">{{ $t("aparcado") }}</td>
                    <td v-else-if="det.status === 'P'">{{ $t("pendiente") }}</td>
                    <td v-else-if="det.status === 'X'">{{ $t("cambio") }}</td>
                    <td v-else-if="det.status === 'N'">{{ $t("anulado") }}</td>
                    <td v-else-if="det.status === 'G'">{{ $t("gasto") }}</td>
                    <td>{{ det.comensales }}</td>
                    <td> {{ det.account === 0 ? det.name : det.account }} </td>
                    <td align="right" v-if="det.status === 'C'">
                      <template v-if="det.amount !== 0">{{
                        totalBase(det) | currency
                      }}</template>
                      <template v-else>{{ 0 | currency }}</template>
                    </td>
                    <td align="center" v-else>--</td>
                    <td align="right" v-if="det.status === 'C'">
                      <template v-if="det.amount !== 0">{{
                        totalImpuesto(det) | currency
                      }}</template>
                      <template v-else>{{ 0 | currency }}</template>
                    </td>
                    <td v-else align="center">--</td>
                    <td align="right">{{ calculateTotal(det) | currency }}</td>
                    <td v-if="det.nameProducto.startsWith('Recarga')" align="right"> {{ 0 | currency }} </td>
                    <td v-else align="right">{{ calculateTotal(det) | currency }}</td>
                    <td align="center">
                      <div class="btn btn-primary btn-link">
                        <i @click="openModal(det.id)" v-tooltip.top-center="$i18n.t('verDesgloseDeImpuestos')"
                          class="fa fa-info-circle"></i>
                      </div>
                      <div class="btn btn-primary btn-link">
                        <i @click="getDetTicketsById(det.id, det.idCode)"
                          v-tooltip.top-center="$i18n.t('verDetallesDetTicket')" class="fa fa-eye text-primary"></i>
                      </div>
                      <div class="btn btn-primary btn-link text-success">
                        <a :href="urlExportTicketExcel(det.id)">
                          <i v-tooltip.top-center="$i18n.t('exportarExcel')"
                            class="fa fa-file-excel text-success"></i></a>
                      </div>
                      <div class="btn btn-primary btn-link text-danger">
                        <a :href="urlExportTicketPDF(det.id)">
                          <i v-tooltip.top-center="$i18n.t('exportarPdf')" class="fa fa-file-pdf text-danger"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr></tr>
                </tfoot>
              </table>
            </el-collapse-item>
          </el-collapse>
          <div v-for="(obj, index) in dateInform" class="table-responsive mt-3" style="overflow: auto">
            <strong>
              {{ obj.nameTpv }} {{ $t("cierre") }}:
              <span :class="getClassDay(obj.day)">{{ obj.day | getDia }} {{ obj.day | parseDate }}
              </span></strong>

            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span v-if="ordenarFecha" @click="sortedArrayASC(1, index), (ordenarFecha = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("fecha") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1, index), (ordenarFecha = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarFactura" @click="sortedArrayASC(2, index), (ordenarFactura = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("factura") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(2, index), (ordenarFactura = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("factura") }}
                    </span>
                  </th>
                  <th v-if="showClienteColumn">
                    {{ $t("cliente") }}
                  </th>
                  <th>
                    {{ $t("agencia") }}
                  </th>
                  <th>
                    <span v-if="ordenarTipo" @click="sortedArrayASC(3, index), (ordenarTipo = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("tipo") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(3, index), (ordenarTipo = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("tipo") }}
                    </span>
                  </th>
                  <th>
                    {{ $t("comensales") }}
                  </th>
                  <th> {{ $t("mesa") }} </th>
                  <th>
                    {{ $t("baseMayusculas") }}
                  </th>
                  <th>{{ $t("IVA") }}</th>
                  <th>
                    <span v-if="ordenarTipo" @click="sortedArrayASC(4, index), (ordenarTotal = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("total") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(4, index), (ordenarTotal = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("total") }}
                    </span>
                  </th>
                  <!-- añado esta columna comprobar si ordena bien-->
                  <th style="width : 5%">
                    <span v-if="ordenarTipo" @click="sortedArrayASC(5, index), (ordernarTotalSinDescuento = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("totalSinDescuento") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(5, index), (ordernarTotalSinDescuento = 1)"><i
                        style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("totalSinDescuento") }}
                    </span>
                  </th>
                  <th width="10%">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="det in obj.headers">
                  <td>
                    <span :class="getClassDay(det.date)">{{ det.date | getDia }}
                      {{ det.date | parseDateMin }}</span>
                  </td>
                  <td>Nº {{ det.idCode }}</td>
                  <td v-if="showClienteColumn">
                    {{ det.nameCliente ? det.nameCliente : "--" }}
                  </td>
                  <!-- <td v-if="det.nameAgencia">{{ det.nameAgencia }}</td>
                  <td v-else>--</td> -->
                  <td>
                    <div class="edit-cell">
                      {{ det.nameAgencia ? det.nameAgencia : "--" }}
                      <!-- se le pasa true para que abra el modal para editar agencia-->
                      <i v-if="actualizarCabeceraOnline" @click="openEditModal(det, true)"
                        v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt" style="color: orange"></i>
                    </div>
                  </td>
                  <td v-if="det.status === 'C'">{{ $t("cobrado") }}</td>
                  <td v-else-if="det.status === 'A'">{{ $t("aparcado") }}</td>
                  <td v-else-if="det.status === 'P'">{{ $t("pendiente") }}</td>
                  <td v-else-if="det.status === 'X'">{{ $t("cambio") }}</td>
                  <td v-else-if="det.status === 'N'">{{ $t("anulado") }}</td>
                  <td v-else-if="det.status === 'G'">{{ $t("gasto") }}</td>
                  <td>
                    <div class="edit-cell">
                      {{ det.comensales }}
                      <i v-if="actualizarCabeceraOnline" @click="openEditModal(det)"
                        v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt" style="color: orange;"></i>
                    </div>
                  </td>
                  <td> {{ det.account === 0 ? det.name : det.account }} </td>
                  <td align="right" v-if="det.status === 'C'">
                    <template v-if="det.amount !== 0">{{
                      totalBase(det) | currency
                    }}</template>
                    <template v-else>{{ 0 | currency }}</template>
                  </td>
                  <td align="center" v-else>--</td>
                  <td align="right" v-if="det.status === 'C'">
                    <template v-if="det.amount !== 0">{{
                      totalImpuesto(det) | currency
                    }}</template>
                    <template v-else>{{ 0 | currency }}</template>
                  </td>
                  <td v-else align="center">--</td>
                  <td align="right">{{ calculateTotal(det) | currency }}</td>
                  <td v-if="det.nameProducto.startsWith('Recarga')" align="right"> {{ 0 | currency }} </td>
                  <td v-else align="right">{{ calculateTotal(det) | currency }}</td>
                  <td align="center">
                    <div class="btn btn-primary btn-link">
                      <i @click="openModal(det.id)" v-tooltip.top-center="$i18n.t('verDesgloseDeImpuestos')"
                        class="fa fa-info-circle"></i>
                    </div>
                    <div class="btn btn-primary btn-link">
                      <i @click="getDetTicketsById(det.id, det.idCode)"
                        v-tooltip.top-center="$i18n.t('verDetallesDetTicket')" class="fa fa-eye text-primary"></i>
                    </div>
                    <div class="btn btn-primary btn-link text-success">
                      <a :href="urlExportTicketExcel(det.id)">
                        <i v-tooltip.top-center="$i18n.t('exportarExcel')"
                          class="fa fa-file-excel text-success"></i></a>
                    </div>
                    <div class="btn btn-primary btn-link text-danger">
                      <a :href="urlExportTicketPDF(det.id)">
                        <i v-tooltip.top-center="$i18n.t('exportarPdf')" class="fa fa-file-pdf text-danger"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>

          <!--<div class="row" v-if="!isSearch && totalPags > 1 && dateInform.length > 0">
            <div class="col-md-12">
              <nav>
                <ul class="pagination flex-wrap">
                  <li class="page-item" :class="{ disabled: pag == 1 }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'facturacion-general', params: { pag: pag - 1 } }"
                      v-if="pag != 1"
                      >&laquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&laquo;</span></span
                    >
                  </li>
                  <li
                    class="page-item"
                    v-for="n in totalPags"
                    :class="{ active: n == pag }"
                  >
                    <router-link
                      class="page-link"
                      :to="{ name: 'facturacion-general', params: { pag: n } }"
                      >{{ n }}
                    </router-link>
                  </li>
                  <li class="page-item" :class="{ disabled: pag == totalPags }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'facturacion-general', params: { pag: nextPag } }"
                      v-if="pag != totalPags"
                    >
                      &raquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&raquo;</span></span
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>-->
          <div class="row overflow-auto">
            <b-pagination v-model="currentPage" :total-rows="totalPags" :per-page="porPagina" :limit="7"
              last-number></b-pagination>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayVentasEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>
    </div>
    <modal name="modal-edit-agencia-fs" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>

        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("cambiarAgencia") }}</h4>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label for="agencias">Agencias</label>
            <el-select class="select-default" size="large" v-model="editedFactura.nuevoIdAgencia" filterable remote
              :placeholder="$t('buscarPorNombreDeAgencia')" :remote-method="searchAgencia">
              <el-option v-for="c in listAgencias" class="select-primary" :value="c.idCode" :label="c.name"
                :key="c.idCode">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
          <button class="btn btn-success" @click="editFactura()">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>

    </modal>
    <modal name="modal-edit-comensales-fs" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>

        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarNumeroComensales") }}</h4>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label for="agencias">Comensales</label>
            <input class="form-control" type="number" placeholder="0" @keydown="$methods.evitarComasDecimales"
              v-model="editedFactura.numComensales" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
          <button class="btn btn-success" @click="editFactura()">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>

    </modal>
    <modal name="desgloseModal" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("desgloseDeImpuestos") }}</h4>
        </div>
        <div class="modal-body">
          <div v-if="listDetallesCab.length > 0" class="table-responsive" style="overflow: auto">
            <table class="table table-bordered table-striped ">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t("tipoIva") }}</th>
                  <th>{{ $t("base") }}</th>
                  <th>{{ $t("impuesto") }}</th>
                  <th>{{ $t("importe") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ref in listDetallesCab">
                  <td>{{ ref.vatType }} %</td>
                  <td>{{ ref.base | currency }}</td>
                  <td>{{ ref.valor | currency }}</td>
                  <td align="right">{{ ref.amount | currency }}</td>
                </tr>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td align="right">
                    <strong>{{ totalDet | currency }}</strong>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>

    <modal name="desglose-ticket-modal" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("desgloseDelTicket") }} {{ nameTickets }}
          </h4>
        </div>
        <div class="modal-body">
          <ticket :ticket="listDesgloseTicket"></ticket>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>

    <!-- Histórico de exportaciones SAP (Fundación Cruzcampo) -->
    <el-dialog title="Últimos informes SAP generados (Fundación Cruzcampo)" :visible.sync="historicoSAPVisible"
      width="75%" :close-on-click-modal="false">

      <div v-if="avisoHistoricoSAP" class="historico-sap-aviso alert"
        :class="'alert-' + avisoHistoricoSAP.tipo">
        <i class="fa" :class="avisoHistoricoSAP.tipo === 'danger' ? 'fa-exclamation-triangle' : 'fa-info-circle'"></i>
        {{ avisoHistoricoSAP.texto }}
      </div>

      <el-table :data="historicoSAP" v-loading="cargandoHistoricoSAP" height="420" stripe
        empty-text="Todavía no hay informes guardados">
        <el-table-column label="Generado" width="160">
          <template slot-scope="scope">
            {{ formatearFechaSAP(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="Periodo del informe" width="210">
          <template slot-scope="scope">
            {{ scope.row.fechaDesde }} — {{ scope.row.fechaHasta }}
          </template>
        </el-table-column>
        <el-table-column prop="downloadName" label="Fichero"></el-table-column>
        <el-table-column label="Tamaño" width="100">
          <template slot-scope="scope">
            {{ formatearTamanoSAP(scope.row.fileSize) }}
          </template>
        </el-table-column>
        <el-table-column label="" width="150" align="right">
          <template slot-scope="scope">
            <el-button size="mini" type="success" :disabled="!scope.row.disponible"
              @click="descargarInformeSAP(scope.row)">
              <i class="fa fa-download"></i>
              Descargar
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <small class="text-muted" style="float: left; padding-top: 8px">
          Se conservan los {{ maximoHistoricoSAP }} últimos informes: al generarse uno nuevo se elimina
          automáticamente el más antiguo.
        </small>
        <el-button size="small" @click="cargarHistoricoSAP()">
          <i class="fa fa-refresh"></i>
          Actualizar
        </el-button>
        <el-button size="small" type="primary" @click="historicoSAPVisible = false">
          Cerrar
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  Loading,
  DropdownMenu,
  Button,
  Switch,
  Collapse,
  CollapseItem,
  Icon,
  Dialog,
  Table,
  TableColumn
} from "element-ui";
import swal from "sweetalert2";
import Datetime from "vue-datetime";
import moment from "moment";
import Ticket from "../../../Widgets/Ticket.vue";
import { mapState, mapMutations } from 'vuex';
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("facturacionGeneral"));

    if (!this.sectores && !this.$cookies.isKey("sectores")) {
      this.getBusiness();
    } else {
      if (this.listaSectores.length > 1) {

        this.idSector = this.listaSectores[0].id;

        //Dentro, establecer un todos como primera opción y después llamar a getTpv()
        this.getBusinessesBySector();
      } else {

        //Cargar método local donde me traigo los sectores
        this.getSectores();

      }
    }





    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Datetime.name]: Datetime,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ticket: Ticket,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      editedFactura: {
        idFactura: "",
        nuevoIdAgencia: "",
        idTpv: "",
        numComensales: 0
      },

      listAgencias: [],
      idBusiness: this.$route.params.idBusiness,
      actualizarCabeceraOnline: false,
      data: [""],
      idTpv: 0,
      idsTPV: [],
      listTpv: [],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      cuentasAparcadas: false,
      dateInform: ["-"],
      dateInformQR: [],
      searchQuery: this.$route.params.query,
      searchQueryLog: '',
      isSearch: this.$route.params.isSearch ? this.$route.params.isSearch : false,
      listDesgloseTicket: [],
      nameTickets: "",

      listTicketsSearch: [],
      listDetallesCab: [],

      //PAGINACION
      pag: this.$route.params.pag,
      totalPags: 0,
      porPagina: 0,
      currentPage: this.$route.params.pag ? this.$route.params.pag : 1,

      //ORDENAR
      ordenarFecha: 0,
      ordenarFactura: 0,
      ordenarTipo: 0,
      ordenarTotal: 0,
      ordenarBase: 0,
      ordenarImpuesto: 0,
      ordernarTotalSinDescuento: 0,

      respuesta: true,

      checkValue: false,
      existeProducto: false,
      showClienteColumn: false,
      exportSapReportWithHeaderDates: false,
      historicoSAPVisible: false,
      historicoSAP: [],
      estadoSAP: null,
      maximoHistoricoSAP: 50,
      cargandoHistoricoSAP: false,
      accordion: '1',
      idTpvAMandar: 0,

      isFR: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        if (this.isSearch) {
          this.searchTickets();
        } else {
          this.getTickets();
        }
      } else if (to.params.query) {
        this.query = to.params.query;
        if (this.isSearch) {
          this.searchTickets();
        } else {
          this.getTickets();
        }
      }
    },
    currentPage() {
      this.$router.push({
        name: 'facturacion-general',
        params: {
          pag: this.currentPage
        },
      });
    }
  },
  computed: {
    ...mapState(["listaSectores", "sectores", "permiso"]),

    /**
     * Semáforo del proceso automático que genera el informe SAP.
     *
     * Se mira la última EJECUCIÓN del cron, no el último fichero: como los días
     * sin ventas no generan nada, quedarse sin informes durante un fin de
     * semana es normal y no debe pintarse como error.
     */
    avisoHistoricoSAP() {
      const estado = this.estadoSAP;

      if (!estado) {
        return null;
      }

      if (!estado.lastRunAt) {
        return {
          tipo: "danger",
          texto: "El proceso automático no se ha ejecutado nunca. Revisa el cron."
        };
      }

      if (estado.lastRunStatus === "error") {
        return {
          tipo: "danger",
          texto: "La última ejecución del proceso automático falló" +
            (estado.lastRunMessage ? ": " + estado.lastRunMessage : ".")
        };
      }

      if (estado.hoursSinceLastRun !== null && estado.hoursSinceLastRun > 26) {
        return {
          tipo: "danger",
          texto: "El proceso automático lleva " + Math.round(estado.hoursSinceLastRun) +
            " horas sin ejecutarse (última vez: " +
            moment(estado.lastRunAt).format("DD-MM-YYYY HH:mm") + "). Revisa el cron."
        };
      }

      if (!estado.lastGeneratedAt) {
        return {
          tipo: "info",
          texto: "El proceso se ejecuta correctamente, pero todavía no ha habido ventas que exportar."
        };
      }

      const horasSinFichero = moment().diff(moment(estado.lastGeneratedAt), "hours");

      if (horasSinFichero > 48) {
        return {
          tipo: "info",
          texto: "El proceso se ejecuta correctamente. Sin ventas que exportar desde el " +
            moment(estado.lastGeneratedAt).format("DD-MM-YYYY") + "."
        };
      }

      return {
        tipo: "success",
        texto: "Proceso automático correcto. Último informe generado el " +
          moment(estado.lastGeneratedAt).format("DD-MM-YYYY HH:mm") + "."
      };
    },

    totalDet() {
      let total = 0;

      this.listDetallesCab.forEach(function (x) {
        total += x.amount;
      });

      return total;
    },

    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
  },
  methods: {
    /* ------------------------------------------------------------------
     * Histórico de exportaciones SAP (Fundación Cruzcampo)
     * El listado lo alimenta el cron nocturno; la limpieza de los informes
     * antiguos la hace la API al guardar cada nuevo fichero.
     * ------------------------------------------------------------------ */

    abrirHistoricoSAP() {
      this.historicoSAPVisible = true;
      this.cargarHistoricoSAP();
    },

    cargarHistoricoSAP() {
      let vm = this;

      const config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      vm.cargandoHistoricoSAP = true;

      this.axios
        .get(this.$store.getters.apiUrl + "sales/getHistoricoSAPCruzcampo", config)
        .then(function (response) {
          vm.cargandoHistoricoSAP = false;

          if (response.data && response.data.success) {
            vm.historicoSAP = response.data.informes;
            vm.estadoSAP = response.data.estado;
            vm.maximoHistoricoSAP = response.data.maximo;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data && response.data.message
                ? response.data.message
                : "No se pudo cargar el histórico de informes SAP.",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error"
            });
          }
        })
        .catch(function () {
          vm.cargandoHistoricoSAP = false;

          swal({
            title: vm.$t("atencion"),
            text: "No se pudo cargar el histórico de informes SAP.",
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error"
          });
        });
    },

    descargarInformeSAP(informe) {
      if (!informe.disponible) {
        swal({
          title: this.$t("atencion"),
          text: "El fichero ya no está disponible en el servidor.",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error"
        });

        return;
      }

      window.open(
        this.$store.getters.apiUrl +
        "sales/descargarInformeSAPCruzcampo?id=" + informe.id +
        "&idBusiness=" + this.idBusiness +
        "&jwt=" + this.$store.getters.jwt
      );
    },

    formatearFechaSAP(fecha) {
      return fecha ? moment(fecha).format("DD-MM-YYYY HH:mm") : "-";
    },

    formatearTamanoSAP(bytes) {
      if (!bytes) {
        return "-";
      }

      return bytes < 1024 * 1024
        ? Math.round(bytes / 1024) + " KB"
        : (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },

    urlExportExcelCompleto() {
      let business = this.idBusiness;
      let sector;
      let url;

      if (!this.sectores && !this.$cookies.isKey("sectores")) {
        if (!Array.isArray(this.idsTPV) || this.idsTPV.length <= 0) {
          this.idsTPV = [this.idTpv];
        }
        sector = false;
      } else {
        sector = true;
        business = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      }

      if (sector) {
        url = this.$store.getters.apiUrl +
          "/sales/exportAllTickets/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          0 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue +
          "&sectores=1";
      } else {
        url = this.$store.getters.apiUrl +
          "/sales/exportAllTickets/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          0 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue;
      }
      window.open(
        url
      );
    },
    urlExportExcelCompletoConDetalles() {
      let business = this.idBusiness;
      let sector;
      let url;

      if (!this.sectores && !this.$cookies.isKey("sectores")) {
        if (!Array.isArray(this.idsTPV) || this.idsTPV.length <= 0) {
          this.idsTPV = [this.idTpv];
        }
        sector = false;
      } else {
        sector = true;
        business = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      }

      if (sector) {
        url = this.$store.getters.apiUrl +
          "/sales/exportAllTickets/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          1 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue +
          "&sectores=1";
      } else {
        url = this.$store.getters.apiUrl +
          "/sales/exportAllTickets/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          1 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue
      }

      window.open(
        url
      );
    },
    urlExportExcelFundacionCruzcampoSAP() {
      let business = this.idBusiness;
      let sector;
      let url;

      if (!this.sectores && !this.$cookies.isKey("sectores")) {
        if (!Array.isArray(this.idsTPV) || this.idsTPV.length <= 0) {
          this.idsTPV = [this.idTpv];
        }
        sector = false;
      } else {
        sector = true;
        business = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      }

      if (sector) {
        url = this.$store.getters.apiUrl +
          "/sales/exportTicketsSAPCruzcampo/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          1 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue +
          "&exportSapReportWithHeaderDates=" + (this.exportSapReportWithHeaderDates ? 1 : 0) +
          "&sectores=1";
      } else {
        url = this.$store.getters.apiUrl +
          "/sales/exportTicketsSAPCruzcampo/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          1 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue + 
          "&exportSapReportWithHeaderDates=" + (this.exportSapReportWithHeaderDates ? 1 : 0)
      }

      window.open(
        url
      );
    },
    urlExportExcelCompletoNatural() {
      const business = this.idBusiness === -1
        ? this.listaSectores[0].idBusinessMaster
        : this.idBusiness;

      const url = this.$store.getters.apiUrl +
        "/sales/exportAllTickets/Excel?idTpv=" +
        this.idsTPV +
        "&idBusiness=" +
        business +
        "&datefrom=" +
        moment(this.datefrom).startOf("day").unix() +
        "&dateto=" +
        moment(this.dateto).endOf("day").unix() +
        "&conDetalles=1" +
        "&porDiaNatural=1" +
        "&jwt=" +
        this.$store.getters.jwt +
        "&checkValue=" +
        this.checkValue +
        "&sectores=1";

      window.open(url);
    },
    ...mapMutations(['changeListaSectores']),
    getSectores() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
        .then(function (response) {

          if (response.data.response) {

            response.data.result["sectores"].forEach((sector) => {
              sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
              sector.id = parseInt(sector.id);
            });

            vm.changeListaSectores(response.data.result["sectores"]);

            vm.idSector = vm.listaSectores[0].id;

            vm.getBusinessesBySector();

          }

        }).catch(function (error) {
          console.log(error);
        })
    },


    checkConfig(idBusiness) {

      //Comprobamos si tiene la config actualizarCabeceraOnline

      let actualizarCabeceraOnlineConfig = 103;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          numConfig: actualizarCabeceraOnlineConfig,
          idBusiness: idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfigByBusiness", config)
        .then(function (response) {

          if (response.data) {
            vm.actualizarCabeceraOnline = response.data.result;

            if (vm.actualizarCabeceraOnline) {
              vm.getAgencias(vm.idBusiness);
            }

          } else {
            swal({
              title: vm.$t("AA"),
              text: "Hubo un error al comprobar configuraciones del negocio",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }


        });

    },

    editFactura() {
      // console.log("FACTURA: " + this.editedFactura.idFactura)
      let comensales = this.editedFactura.numComensales;
      // console.log("AGENCIA: " + this.editedFactura.nuevoIdAgencia);
      if (this.isFR && this.editedFactura.numComensales > 0) {
        comensales = comensales * -1
      }
      // console.log(comensales);
      let config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: this.editedFactura.idTpv,
          idHeader: this.editedFactura.idFactura,
          agenciaId: this.editedFactura.nuevoIdAgencia,
          comensales: comensales,
          jwt: this.$store.getters.jwt
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      var params = {
        idBusiness: this.idBusiness,
        idTpv: this.editedFactura.idTpv,
        idHeader: this.editedFactura.idFactura,
        agenciaId: this.editedFactura.nuevoIdAgencia,
        comensales: comensales,
        jwt: this.$store.getters.jwt
      };

      let vm = this;


      this.axios.post(this.$store.getters.apiUrl + "tickets/editAgenciaYComensalesTicket", params, config)
        .then(function (response) {
          if (response.data.response) {

            vm.$notify({
              message:
                vm.$t("facturaEditadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.cerrarModal();
            vm.getTickets();

          } else {
            //swal hubo un error al editar
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

        })

    },

    searchAgencia(query) {

      this.getAgencias(this.idBusiness);

      if (query !== '') {
        const controller = 'searchAgenciasByBusiness/' + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        let vm = this;
        this.axios.get(this.$store.getters.apiUrl + "agencias/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              // console.log(response.data.result.agencias)
              vm.listAgencias = response.data.result.agencias;

            }
            else {
              swal({
                title: vm.$t('atencion'),
                text: response.data.message,
                confirmButtonClass: 'btn btn-info btn-fill',
                type: 'error'
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }

    },
    getAgencias(idBusiness) {

      var config = {
        params: {
          idBusiness: idBusiness,
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "agencias/getAgenciasByBusinessNoPage", config)
        .then(function (response) {

          if (response.data) {

            // console.log(vm.listAgencias);
            // vm.listAgencias = [];

            // response.data.result.forEach(
            //   (agencias) => {vm.listAgencias.push(agencias)}
            // )

            // console.log(vm.listAgencias);

            vm.listAgencias = response.data.result;

            let sinAgencia = {
              id: 0,
              name: "Sin Agencia",
              idCode: 0
            }

            vm.listAgencias.push(sinAgencia);



          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.message,
              confirmButtonClass: 'btn btn-info btn-fill',
              type: 'error'
            });
          }

        }
        );

    },

    exportForm(formato, tipo) {
      let treinta_y_un_dias_en_segundos = 2678400;
      if ((treinta_y_un_dias_en_segundos - (moment(this.dateto).startOf("day").unix() - moment(this.datefrom).startOf("day").unix())) > 0) {
        if (tipo == "Completo") {
          this.urlExportExcelCompleto();
        } else if (tipo == "CompletoDetalles") {
          this.urlExportExcelCompletoConDetalles();
        } else if (tipo == "CompletoDetallesNatural") {
          this.urlExportExcelCompletoNatural();
        } else if (tipo == "FUNDACION_CRUZCAMPO_SAP") {
          this.urlExportExcelFundacionCruzcampoSAP();
        }

      } else {
        swal({
          title: this.$t("loSentimos"),
          text: this.$t("soloPuedesSacarInformesDeUnMesComoMaximo"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
    getBusinessesBySector() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      var params = {
        idBusiness: this.listaSectores[0].idBusinessMaster,
        idSector: this.idSector,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
        .then(function (response) {

          if (response.data.response) {

            //Recojo todos los negocios de la carga inicial del sector seleccionado

            vm.listBusinesses = response.data.result;
            vm.idBusiness = -1;

            //Recojo todos los tpv
            vm.getAllTpvFromBusinesses();

          }

        }).catch(function (error) {
          console.log(error);
        })
    },
    getAllTpvFromBusinesses() {

      let businesses = [];

      this.listBusinesses.forEach(business => {

        if (business.id != -1) {
          businesses.push(parseInt(business.id));
        }

      });

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: businesses,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
        .then(function (response) {

          if (response.data.response) {
            vm.listTpv = [];
            vm.idsTPV = [];

            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            vm.getTickets();
            vm.grafica = 0;
          }
          vm.loading.close();

        }).catch(function (error) {
          console.log(error);
        })
    },
    totalImpuesto(ivas) {
      const totalSinDescuento = ivas.totalSinDescuento;
      const totalConDescuento = ivas.amount;

      const factorDescuento = totalConDescuento / totalSinDescuento;

      let totalIva = 0;

      ivas.ivas.forEach(function (x) {
        // Total de esta línea con descuento aplicado
        const totalLineaConDescuento = x.total * factorDescuento;

        // Base imponible ajustada
        const base = totalLineaConDescuento / ((x.iva + 100) / 100);

        // IVA ajustado
        const iva = totalLineaConDescuento - base;

        totalIva += iva;
      });

      return totalIva;
    },

    calculateTotal(ivas) {
      let total = 0;

      ivas.ivas.forEach(function (x) {
        total += x.total;
      });

      return total;
    },

    totalBase(ivas) {
      var total = 0;

      ivas.ivas.forEach(function (x) {
        total += x.total / ((x.iva + 100) / 100);
      });

      return total;
    },

    sortedArrayASC: function (nameAtributo, index) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 1;

          function compareDate(a, b) {
            if (a.date.toUpperCase() < b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() > b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareDate);

        case 2:
          this.ordenarFactura = 1;

          function compareFactura(a, b) {
            if (a.idCode.toUpperCase() < b.idCode.toUpperCase()) return -1;
            if (a.idCode.toUpperCase() > b.idCode.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareFactura);

        case 3:
          this.ordenarTipo = 1;

          function compareTipo(a, b) {
            if (a.status.toUpperCase() < b.status.toUpperCase()) return -1;
            if (a.status.toUpperCase() > b.status.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTipo);

        case 4:
          this.ordenarTotal = 1;

          function compareTotal(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);

        case 5:
          this.ordernarTotalSinDescuento = 1;

          function compareTotal(a, b) {
            if (a.totalSinDescuento < b.totalSinDescuento) return -1;
            if (a.totalSinDescuento > b.totalSinDescuento) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);
      }
    },
    sortedArrayDESC: function (nameAtributo, index) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 0;

          function compareDate(a, b) {
            if (a.date.toUpperCase() > b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() < b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareDate);

        case 2:
          this.ordenarFactura = 0;

          function compareFactura(a, b) {
            if (a.idCode.toUpperCase() > b.idCode.toUpperCase()) return -1;
            if (a.idCode.toUpperCase() < b.idCode.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareFactura);

        case 3:
          this.ordenarTipo = 0;

          function compareTipo(a, b) {
            if (a.status.toUpperCase() > b.status.toUpperCase()) return -1;
            if (a.status.toUpperCase() < b.status.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTipo);

        case 4:
          this.ordenarTotal = 0;

          function compareTotal(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);

        case 5:
          this.ordernarTotalSinDescuento = 0;

          function compareTotal(a, b) {
            if (a.totalSinDescuento > b.totalSinDescuento) return -1;
            if (a.totalSinDescuento < b.totalSinDescuento) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);
      }
    },

    getBusiness() {



      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.checkConfig(vm.idBusiness);
          //vm.getAgencias(vm.idBusiness);
          vm.cambioTpv(-1, false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openModal(idHeader) {
      this.getTicketsDet(idHeader);

      this.$modal.show("desgloseModal");
    },

    cerrarModal() {

      this.getAgencias(this.idBusiness)


      this.$modal.hide("desgloseModal");
      this.$modal.hide("desglose-ticket-modal");
      this.$modal.hide("modal-edit-agencia-fs")
      this.$modal.hide("modal-edit-comensales-fs")
    },

    getTicketsDet(idHeader) {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom)
          .startOf("day")
          .unix();
        let secondsHasta = moment(this.dateto)
          .endOf("day")
          .unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          const controller = "getTicketsDetailsById";

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idHeader: idHeader,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "sales/" + controller, config)
            .then(function (response) {
              if (response.data.response) {
                vm.listDetallesCab = response.data.result;
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    openEditModal(factura, isAgencia = false) {

      //this.idFactura = factura.id
      //this.nombreFactura = factura.nameAgencia
      //this.nuevoIdAgencia = factura.idAgencia;

      this.editedFactura = {
        idFactura: factura.id,
        nuevoIdAgencia: factura.idAgencia,
        idTpv: factura.idTpv,
        numComensales: factura.comensales
      }

      if (isAgencia) {
        this.$modal.show("modal-edit-agencia-fs");
      } else {
        this.isFR = factura.idCode.includes("FR")
        //  console.log(this.isFR)
        this.$modal.show("modal-edit-comensales-fs")
      }



    },
    cambioBusiness(idBusinessData, listTpv) {
      this.checkConfig(idBusinessData);
      //this.getAgencias(idBusinessData);

      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.idsTPV = [];

      if ((!this.sectores && !this.$cookies.isKey("sectores")) || idBusinessData != -1) {
        this.cambioTpv(-1);
      } else {
        this.getAllTpvFromBusinesses();
      }
    },
    emitirConsulta() {
      if (this.isSearch) {
        this.searchTickets();
      } else {
        this.getTickets();
      }
    },
    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
        this.changeTPV();
      }
      this.isSearch = false;
      this.searchQuery = '';
      this.emitirConsulta();
    },
    changeTPV() {
      if (this.idTpv === -1) {
        this.idsTPV = [];

        for (let i = 0; i < this.listTpv.length; i++) {
          this.idsTPV.push(this.listTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }

    },
    cambioSector(idSectorData, listBusinesses) {

      if (listBusinesses) {
        this.listBusinesses = listBusinesses;
      }

      this.idSector = idSectorData;
      this.idBusiness = -1;
      this.getAllTpvFromBusinesses();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];
      this.idsTPV = [];
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;

            response.data.result.forEach(tpv => {
              vm.idsTPV.push(tpv.id);
            });

            if (vm.listTpv.length > 0) {
              vm.idTpv = 0;
              vm.getTickets();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },

    getTickets() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom)
          .startOf("day")
          .unix();
        let secondsHasta = moment(this.dateto)
          .endOf("day")
          .unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          const controller = "getTickets";

          if (this.isSearch) {
            this.pag = 1;
          }

          if ((!this.sectores && !this.$cookies.isKey("sectores"))) {
            if (!Array.isArray(this.idsTPV) || this.idsTPV.length <= 0) {
              this.idsTPV = [this.idTpv];
            }
          }

          this.isSearch = false;
          this.searchQuery = '';

          var config = {
            params: {
              idTpv: this.idsTPV,
              idBusiness: this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness,
              pag: this.pag,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              checkValue: this.checkValue,
              completo: 1,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
          // console.log(config.params["idBusiness"])
          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "sales/" + controller, config)
            .then(function (response) {


              // console.log(response.data)
              // console.log(response.data.response.tickets);

              if (response.data.response) {
                vm.respuesta = true;

                vm.dateInform = response.data.result.tickets;
                vm.dateInformQR = response.data.result.ticketsQR;

                // console.log("dateInform");
                // console.log(vm.dateInform);
                // console.log("data.result.tickets");
                // console.log(response.data.result.tickets);

                vm.pag = response.data.result.pag;
                vm.totalPags = response.data.result.totalPags;
                vm.porPagina = 1;
                vm.existeProducto = response.data.result.existeProducto

              } else if (response.data.response == false && response.data.rangoMayor == true) {
                swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                });
                vm.respuesta = false;

              } else {

                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },

    searchTickets() {
      this.loading = Loading.service({ text: "Cargando..." });

      // Eliminar prefijo "Nº", "N°", "No", etc.
      let search = (this.searchQuery || "").trim();
      search = search.replace(/^(n[º°o.]?\s*)/i, "");

      const controller = search
        ? "searchTicketsByBusiness"
        : "getTickets";

      if (this.isSearch) {
        this.pag = 1;
      }

      if (this.searchQueryLog != this.searchQuery) {
        this.pag = 1;
      }

      this.searchQueryLog = this.searchQuery;

      if (!this.sectores && !this.$cookies.isKey("sectores")) {
        if (!Array.isArray(this.idsTPV) || this.idsTPV.length <= 0) {
          this.idsTPV = [this.idTpv];
        }
      }

      var config = {
        params: {
          query: search,
          idTpv: this.idsTPV,
          idBusiness:
            this.idBusiness == -1
              ? this.listaSectores[0].idBusinessMaster
              : this.idBusiness,
          pag: this.pag,
          datefrom: moment(this.datefrom)
            .startOf("day")
            .unix(),
          dateto: moment(this.dateto)
            .endOf("day")
            .unix(),
          checkValue: this.checkValue,
          completo: 1,
          jwt: this.$store.getters.jwt
        },
        headers: {
          Authorization: "Bearer " + this.$store.getters.jwt
        }
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      this.axios
        .get(this.$store.getters.apiUrl + "sales/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.dateInform = response.data.result.tickets;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;
            vm.porPagina = 1;
            vm.isSearch = true;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
          vm.loading.close();
        });
    },

    getDetTicketsById(idHeader, name) {
      this.listDesgloseTicket = [];
      this.nameTickets = name;

      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idHeader: idHeader,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "sales/getDetTicketsById", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listDesgloseTicket = response.data.result[0];
            vm.$modal.show("desglose-ticket-modal");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getClassDay(date) {
      var classDay = "";
      var humanDate = moment.unix(date);
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },

    /*urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTicket/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },*/
    urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidaById/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketExcel(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTicket/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
};
</script>
<style>
.collapseContainer .el-collapse {
  margin-top: 25px;
  border-top: 1px solid #f7f7f8;
  /*#AAAAAA;/*rgb(165, 165, 165);*/
  border-bottom: 1px solid #f7f7f8;
}

.collapseContainer .el-collapse-item__arrow {
  margin-left: 20px;
}

.collapseContainer .el-collapse-item__header {

  border-bottom: 1px solid #f7f7f8;
  /*#AAAAAA;/*rgb(165, 165, 165);*/
  margin-bottom: 15px;
}
</style>
<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.edit-cell {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap
}

.div-export {
  margin-bottom: 10px;
}

.div-export>.col-md-6,
.div-export>.export-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* gap: 12px; */
}

.export-toolbar__option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 8px 8px;
  flex: 0 1 auto;
}

.export-toolbar__option label {
  margin: 0;
}

.export-toolbar__check {
  cursor: pointer;
  white-space: nowrap;
}

.export-toolbar__check input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
}

.div-export .input-group {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}

.div-export .input-group .form-control {
  min-width: 0;
  flex: 1 1 auto;
}

.div-export .input-group-append {
  display: flex;
}

.export-toolbar-switches {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
}

/* Botón secundario: consultar el histórico no compite con la acción principal
   (exportar), por eso va en gris perfilado y no en color sólido. */
.btn-historico-sap {
  margin-left: 18px;
  padding: 7px 14px;
  color: #5a5e66;
  background-color: #fff;
  border-color: #dcdfe6;
  font-weight: 600;
  letter-spacing: 0.2px;
  transition: all 0.2s ease;
}

/* Separador sutil respecto al desplegable de exportar. */
.btn-historico-sap::before {
  content: "";
  position: absolute;
  left: -9px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 20px;
  background-color: #e4e7ed;
}

.btn-historico-sap {
  position: relative;
}

.btn-historico-sap:hover,
.btn-historico-sap:focus {
  color: #303133;
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}

.btn-historico-sap .fa {
  margin-right: 5px;
  opacity: 0.7;
}

.historico-sap-aviso {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 0.92em;
}

@media (max-width: 1109px) {
  .div-export>.col-md-6,
  .div-export>.export-toolbar {
    flex: 1 1 100%;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .export-toolbar__option,
  .export-toolbar__check {
    width: 100%;
    white-space: normal;
  }
  .btn-historico-sap {
    margin-left: 0;
  }
  .btn-historico-sap::before {
    display: none;
  }
  .export-toolbar-switches {
    flex-direction: column;
    align-items: flex-end;
  }
  .export-toolbar-switches .export-toolbar__option {
    width: auto;
  }
  .div-export .input-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .div-export .input-group .form-control {
    width: 100%;
    border-radius: 0.25rem;
    border-right: 1px solid #ced4da;
  }
  .div-export .input-group-append {
    width: 100%;
    display: flex;
    gap: 8px;
  }
  .div-export .input-group-append .btn {
    flex: 1 1 auto;
    width: auto;
  }
}

@media (max-width: 1450px) {
  .export-toolbar-switches {
    flex-direction: column;
    align-items: flex-end;
  }
}

.sunday {
  color: rgb(128, 0, 0);
}

.fridaySaturday {
  color: rgb(0, 128, 64);
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/FacturacionGeneral.vue